import { render, staticRenderFns } from "./PopOverSearch.vue?vue&type=template&id=03cdd0c3&scoped=true&"
import script from "./PopOverSearch.vue?vue&type=script&lang=js&"
export * from "./PopOverSearch.vue?vue&type=script&lang=js&"
import style0 from "./PopOverSearch.vue?vue&type=style&index=0&id=03cdd0c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cdd0c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03cdd0c3')) {
      api.createRecord('03cdd0c3', component.options)
    } else {
      api.reload('03cdd0c3', component.options)
    }
    module.hot.accept("./PopOverSearch.vue?vue&type=template&id=03cdd0c3&scoped=true&", function () {
      api.rerender('03cdd0c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/search/PopOverSearch.vue"
export default component.exports